import { computed, ref } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
export const useInputMask = () => {
  const {
    locale
  } = useI18n();
  const isLocaleFR = computed(() => locale.value === "fr-CA");
  const currencyIconLeft = computed(() => !isLocaleFR.value);
  const buildCurrencyMask = options => {
    const currencyGroupSeparator = computed(() => isLocaleFR.value ? " " : ",");
    const inputMask = computed(() => {
      var _options$allowMinus$v, _options$allowMinus;
      return {
        alias: "currency",
        rightAlign: false,
        prefix: "",
        showMaskOnHover: false,
        autoUnmask: true,
        unmaskAsNumber: true,
        groupSeparator: currencyGroupSeparator.value,
        allowMinus: (_options$allowMinus$v = options == null ? void 0 : (_options$allowMinus = options.allowMinus) == null ? void 0 : _options$allowMinus.value) != null ? _options$allowMinus$v : false,
        enforceDigitsOnBlur: false
      };
    });
    return {
      inputMask
    };
  };
  const buildNumberMask = options => {
    const inputMask = computed(() => {
      var _options$min, _options$max;
      return {
        alias: "numeric",
        rightAlign: false,
        prefix: "",
        showMaskOnHover: false,
        autoUnmask: true,
        unmaskAsNumber: true,
        min: options == null ? void 0 : (_options$min = options.min) == null ? void 0 : _options$min.value,
        max: options == null ? void 0 : (_options$max = options.max) == null ? void 0 : _options$max.value
      };
    });
    return {
      inputMask
    };
  };
  const buildIntegerMask = options => {
    const inputMask = computed(() => {
      var _options$min2, _options$max2;
      return {
        alias: "integer",
        rightAlign: false,
        prefix: "",
        showMaskOnHover: false,
        autoUnmask: true,
        unmaskAsNumber: true,
        min: options == null ? void 0 : (_options$min2 = options.min) == null ? void 0 : _options$min2.value,
        max: options == null ? void 0 : (_options$max2 = options.max) == null ? void 0 : _options$max2.value
      };
    });
    return {
      inputMask
    };
  };
  const buildDecimalMask = options => {
    const inputMask = computed(() => {
      var _options$digits, _options$digitsOption, _options$min3, _options$max3;
      return {
        alias: "decimal",
        rightAlign: false,
        prefix: "",
        showMaskOnHover: false,
        autoUnmask: true,
        unmaskAsNumber: true,
        digits: options == null ? void 0 : (_options$digits = options.digits) == null ? void 0 : _options$digits.value,
        digitsOptional: options == null ? void 0 : (_options$digitsOption = options.digitsOptional) == null ? void 0 : _options$digitsOption.value,
        min: options == null ? void 0 : (_options$min3 = options.min) == null ? void 0 : _options$min3.value,
        max: options == null ? void 0 : (_options$max3 = options.max) == null ? void 0 : _options$max3.value,
        groupSeparator: "."
      };
    });
    return {
      inputMask
    };
  };
  const buildDateMask = () => {
    const inputMask = computed(() => {
      return {
        mask: "9999-99-99",
        showMaskOnHover: false,
        autoUnmask: false,
        greedy: false,
        placeholder: "YYYY-MM-DD"
      };
    });
    return {
      inputMask
    };
  };
  const buildCanadianPostalCode = () => {
    const inputMask = computed(() => {
      return {
        mask: "A9A 9A9",
        greedy: false,
        showMaskOnHover: false,
        definitions: {
          "*": {
            casing: "upper",
            validator: "[\\w]"
          }
        }
      };
    });
    return {
      inputMask
    };
  };
  const buildCanadianSinMask = () => {
    const inputMask = computed(() => {
      return {
        mask: "*** *** ***",
        placeholder: "XXX XXX XXX",
        greedy: false,
        autoUnmask: true,
        clearIncomplete: true,
        showMaskOnHover: false,
        definitions: {
          "*": {
            casing: "upper",
            validator: "[\\d|X]"
          }
        }
      };
    });
    return {
      inputMask
    };
  };
  const buildMaskFromStringType = fromStringOptions => {
    if (fromStringOptions.type === "currency") return buildCurrencyMask(fromStringOptions.options);
    if (fromStringOptions.type === "decimal" || fromStringOptions.type === "percentage") return buildDecimalMask(fromStringOptions.options);
    if (fromStringOptions.type === "number") return buildNumberMask(fromStringOptions.options);
    if (fromStringOptions.type === "integer") return buildIntegerMask(fromStringOptions.options);
    if (fromStringOptions.type === "date") return buildDateMask();
    if (fromStringOptions.type === "can-postal") return buildCanadianPostalCode();
    if (fromStringOptions.type === "can-sin") return buildCanadianSinMask();
    if (fromStringOptions.type === "phone") return buildPhoneNumberMask();
    if (fromStringOptions.type === "phone-ext") return buildPhoneNumberMask({
      withExtension: ref(true)
    });
    throw `type: '${fromStringOptions.type}' option is not one of the defined values`;
  };
  const buildPhoneNumberMask = options => {
    const phoneMaskDefinition = computed(() => {
      var _options$withExtensio;
      return options != null && (_options$withExtensio = options.withExtension) != null && _options$withExtensio.value ? "(999) 999-9999 Ext. [999999]" : "(999) 999-9999";
    });
    const inputMask = computed(() => {
      return {
        mask: phoneMaskDefinition.value,
        greedy: false,
        showMaskOnHover: false
      };
    });
    return {
      inputMask
    };
  };
  return {
    buildCurrencyMask,
    currencyIconLeft,
    buildDecimalMask,
    buildDateMask,
    buildCanadianPostalCode,
    buildCanadianSinMask,
    buildMaskFromStringType,
    buildNumberMask,
    buildPhoneNumberMask
  };
};